import { gql } from '@apollo/client';
import { DOCUMENT_FRAGMENT } from './documentFragment';
import { AGENCY_COVERAGE_FRAGMENT } from './agencyCoverageFragment';
import { AGENCY_CONTRACT_FRAGMENT } from './agencyContractFragment';
import { W9_FRAGMENT } from './W9Fragment';
import { BANK_ACCOUNT_FRAGMENT } from './bankAccountFragment';

export const AGENCY_FRAGMENT = gql`
  fragment AgencyFragment on Agency {
    id
    email
    phone
    agencyCode
    agencyServiceFeeInCents
    aonStatus
    checkoutVisibility
    commercialLinesPercentage
    commercialLinesYears
    commercialQuotesPerMonth
    complianceStatus
    coveredEo
    dba
    directAppointments
    eligibleToUsePlatform
    floridaLicenseNumber
    hasBusinesses
    hasSamePostalAddress
    licenseExpirationDate
    licensedInFlorida
    licensedPc
    logo
    managementSystem
    mgas
    name
    npn
    sizeOfBook
    status
    website
    zipCode
    city
    state
    streetLine1
    streetLine2
    postalAddress {
      ...AddressFragment
    }
    contract {
      ...AgencyContractFragment
    }
    licenseDocument {
      ...DocumentFragment
    }
    plCoverage {
      ...AgencyCoverageFragment
    }
    w9 {
      ...W9Fragment
    }
    bankAccount {
      ...BankAccountFragment
    }
  }
  ${DOCUMENT_FRAGMENT}
  ${AGENCY_COVERAGE_FRAGMENT}
  ${AGENCY_CONTRACT_FRAGMENT}
  ${W9_FRAGMENT}
  ${BANK_ACCOUNT_FRAGMENT}
`;
